<template>
  <div :class="containerClasses">
    <span :class="previousClasses" @click="showPreviousPage">
      <i v-show="hasPreviousPage" class="fa fa-arrow-left" />
    </span>
    <span :class="switchClasses" @click="$emit('header-click')">
      {{ headerText }}
    </span>
    <span :class="nextClasses" @click="showNextPage">
      <i v-show="hasNextPage" class="fa fa-arrow-right" />
    </span>
  </div>
</template>

<script>
import classNames from 'classnames'

const PeriodPickerHeader = {
  props: {
    headerText: [String, Number],
    hasPreviousPage: Boolean,
    hasNextPage: Boolean,
    newLayout: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['show-previous-page', 'show-next-page', 'header-click'],
  computed: {
    containerClasses() {
      if (this.newLayout) {
        return [
          'tw-grid',
          'tw-grid-cols-[2fr_5fr_2fr]',
          'tw-items-center',
          'tw-w-full',
          'tw-font-medium',
          'tw-text-sf-slate-dark-1',
          'tw-border-b',
          'tw-border-solid',
          'tw-border-x-0',
          'tw-border-t-0',
          'tw-border-sf-slate-lighter-1',
        ]
      }
      return ['period-picker-header']
    },
    previousClasses() {
      return this.arrowItemClasses({
        available: this.hasPreviousPage,
        side: 'prev',
      })
    },
    nextClasses() {
      return this.arrowItemClasses({
        available: this.hasNextPage,
        side: 'next',
      })
    },
    switchClasses() {
      if (this.newLayout) {
        return [
          'tw-h-10',
          'tw-leading-10',
          'tw-m-1',
          'tw-text-center',
          'tw-rounded-md',
          'tw-cursor-pointer',
          'hover:tw-bg-sf-slate-subtle-2',
        ]
      }
      return ['period-picker-header-item', 'switch']
    },
  },
  methods: {
    arrowItemClasses({ available, side }) {
      if (!this.newLayout) {
        return classNames([side, 'period-picker-header-item'], {
          'not-visible': !available,
        })
      }

      const base = [
        'tw-h-10',
        'tw-leading-10',
        'tw-m-1',
        'tw-text-center',
        'tw-rounded-md',
      ]

      if (available) {
        base.push('tw-cursor-pointer', 'hover:tw-bg-sf-slate-subtle-2')
      } else {
        base.push('tw-invisible', 'tw-cursor-default')
      }

      return base
    },
    showPreviousPage() {
      if (this.hasPreviousPage) {
        this.$emit('show-previous-page')
      }
    },
    showNextPage() {
      if (this.hasNextPage) {
        this.$emit('show-next-page')
      }
    },
  },
}

export default PeriodPickerHeader
</script>
